import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="18" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8 12h2c.55 0 1-.45 1-1s-.45-1-1-1H8c-.55 0-1 .45-1 1s.45 1 1 1zM0 1c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H1C.45 0 0 .45 0 1zm4 6h10c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1z" fill="#07A" /></svg>;